import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.palette.tokens.space[4],
}));

export const Timeline = styled('ol')(() => ({
  listStyle: 'none',
  margin: 0,
  padding: '4px 0 0 4px',
  display: 'flex',
  flexDirection: 'column',
}));

export const Milestone = styled('li', {
  shouldForwardProp: (prop) => prop !== 'isLast' && prop !== 'isFuture',
})<{ isLast: boolean; isFuture: boolean }>(({ theme, isLast, isFuture }) => ({
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: '18px 150px minmax(0, 1fr)',
  columnGap: theme.palette.tokens.space[3],
  alignItems: 'start',
  paddingBottom: isLast ? 0 : theme.palette.tokens.space[4],
  opacity: isFuture ? 0.7 : 1,

  '&::before': {
    content: '""',
    position: 'absolute',
    left: '8px',
    top: '14px',
    bottom: 0,
    width: '2px',
    backgroundColor: isLast ? 'transparent' : theme.palette.divider,
  },

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '18px minmax(0, 1fr)',
    '& > :last-of-type': { gridColumn: '2' },
  },
}));

export const MilestoneDot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isFuture',
})<{ isFuture: boolean }>(({ theme, isFuture }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  border: `4px solid ${theme.palette.background.paper}`,
  backgroundColor: isFuture
    ? theme.palette.tokens.color.n300
    : theme.palette.tokens.color.action,
  boxShadow: `0 0 0 1px ${theme.palette.divider}`,
  marginTop: '2px',
}));

export const MilestoneDate = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.palette.tokens.space[2],
  ...theme.typography.body2,
  fontWeight: theme.palette.tokens.font.weightMedium,
  fontVariantNumeric: 'tabular-nums',
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
}));

export const MilestoneTime = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
}));

export const MilestoneLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));

export const TimelineEmpty = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));

export const FilesToolbar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.palette.tokens.space[3],
  flexWrap: 'wrap',
}));

export const FilesToolbarLeft = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[4],
  flexWrap: 'wrap',
  '& .MuiFormControlLabel-label': {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
  },
}));

export const FileTypeCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[3],
  minWidth: 0,
  '& strong': { fontWeight: theme.palette.tokens.font.weightMedium },
}));

export const FileTypeIcon = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: `${theme.palette.tokens.radius.control}px`,
  backgroundColor: theme.palette.tokens.color.n100,
  color: theme.palette.text.secondary,
  flexShrink: 0,
  '& span': { fontSize: '20px' },
}));

export const RelatedDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));
